module.exports = __webpack_public_path__ + "img/c4.54bbf218.jpg";